module.exports = __webpack_public_path__ + "static/hero-311eda51351cc4b1d3865a4966af3966.png";